define(['idcta-v2/experiment-snippet'], function() {
    window.optimizely = window.optimizely || [];

    return {
        bucketUser: function(pageName) {
            window.optimizely.push({
                type: 'page',
                pageName: pageName,
            });
        },
        getVariantName: function(experimentId) {
            try {
                var state = window.optimizely.get('state');
                var experimentState = state.getExperimentStates({
                    isActive: true,
                });
                var experimentData = experimentState[experimentId];
                return experimentData ? experimentData.variation.name : null;
            } catch (error) {
                return null;
            }
        },
        sendAttributes: function(attributes) {
            window.optimizely.push({
                type: 'user',
                attributes: attributes,
            });
        },
        sendEvent: function(event) {
            window.optimizely.push({
                type: 'event',
                eventName: event,
            });
        },
    };
});
